import axios from "axios";
import React, { useEffect, useState } from "react";
import Select from "react-select";

const SimilarBlogs = ({ similarBlogs, setSimilarBlogs, currentBlog }) => {
  const [allBlogs, setAllBlogs] = useState([]);
  async function getBlogsListGraphql() {
    try {
      const response = await axios({
        url: `${process.env.REACT_APP_BASE_SIGNIN_URL}/graphql`,
        method: "POST",
        headers: {
          "Content-Type": "application/json",
          jwt_token: localStorage.getItem("admin_user_token"),
        },
        timeout: 120000,
        data: {
          query: `
            query Getblogs {
                    getblogs {
                        blogs {
                            id
                            blog_title
                            blog_slug
                            status
                        }
                    }
                }

          `,
        },
      });

      const response_data = response?.data?.data?.getblogs;
      setAllBlogs(response_data?.blogs?.filter(
        (blog) => blog.status ==1 && blog?.blog_title && blog?.blog_slug
      ) || []);
    } catch (error) {
      console.log(error);
      setAllBlogs([]);
    }
  }

  useEffect(() => {
    if (!allBlogs.length) {
      getBlogsListGraphql();
    }
  }, []);

  //   antd Select with search to select similar blogs from allBlogs
  return (
    <div className="">
      {similarBlogs.map((blog, index) => (
        <div key={index} className="mb-2 flex space-x-2 ">
          <Select
          className="w-full"
            options={allBlogs?.map((b) => ({
              value: b.id,
              label: b.blog_title,
            }))}
            value={
              blog.id
                ? {
                    value: blog.id,
                    label:
                      allBlogs.find((b) => b.id === blog.id)
                        ?.blog_title || blog.blog_title,
                  }
                : null
            }
            onChange={(selectedOption) => {
              const updatedSimilarBlogs = [...similarBlogs];
              updatedSimilarBlogs[index] = {
                ...updatedSimilarBlogs[index],
                blog_title: selectedOption.label,
                id: selectedOption.value,
              };
              setSimilarBlogs(updatedSimilarBlogs);
            }}
            placeholder="Select Similar Blog"
            isSearchable
            filterOption={(option) =>
              !similarBlogs?.find((blog) => blog?.id == option?.value) && option.value != currentBlog.id
            }
            // zindex to ensure dropdown appears above other elements
            styles={{
              menu: (provided) => ({ ...provided, zIndex: 9999 }),
            }}
          />
          <button
            className="btn btn-danger btn-sm "
            onClick={() => {
              const updatedSimilarBlogs = similarBlogs.filter(
                (_, i) => i !== index
              );
              setSimilarBlogs(updatedSimilarBlogs);
            }}
          >
            Remove
          </button>
        </div>
      ))}
    </div>
  );
};

export default SimilarBlogs;
